export class KeyCodeConstants {
	public static readonly ENTER: number = 13;
}
